const ROLE_KEY = 'authRole';
const TOKEN_KEY = 'authToken';

const Auth = {
  isLoggedIn() {
    return this.token() != null;
  },

  isPermissioned(role) {
    if (role) {
      return localStorage.getItem(ROLE_KEY) === role;
    }

    return true;
  },

  login(jwt, role) {
    localStorage.setItem(TOKEN_KEY, 'Bearer ' + jwt);
    localStorage.setItem(ROLE_KEY, role);
  },

  logout() {
    localStorage.removeItem(TOKEN_KEY);
  },

  token() {
    return localStorage.getItem(TOKEN_KEY);
  },
};

export default Auth;



// WEBPACK FOOTER //
// ./src/utils/auth.js